// extracted by mini-css-extract-plugin
export default {"styles":"WHHeader_styles__Oqkas"};